class SortBy extends window.BAO.CustomElement({
  SuperClass: HTMLSelectElement,
}) {
  constructor () {
    super()

    switch (this.dataset.type) {
      case 'search':
        this.eventBus = window.theme.searchResults.eventBus
        this.state = {
          root: window.theme.searchResults?.stateLayer?.state || {
            products: [],
          },
          observer: null,
        }
        break
      case 'autocomplete':
        this.eventBus = window.theme.autocompleteResults.eventBus
        this.state = {
          root: window.theme.autocompleteResults?.stateLayer?.state || {
            products: [],
          },
          observer: null,
        }
        break
      default:
        // Default is collection
        this.eventBus = window.theme.category.eventBus
        this.state = {
          root: window.theme.category?.stateLayer?.state || { products: [] },
          observer: null,
        }
    }
  }

  connectedCallback () {
    this.subscribeToEvents()
  }

  subscribeToEvents () {
    this.addEventListener('change', () => {
      const value = this.value

      this.eventBus.publish('state:sort:updated', value)
    })
  }
}

window.customElements.define('sort-by', SortBy, {
  extends: 'select',
})
